import React from "react";
import Image from "next/image";
import { useMediaQuery } from "react-responsive";
import cn from "classnames";
import { SolutionType } from "@/components/common/solutions";
import { Button } from "@/components/common/Button";
import useRedirectToBlog from "@/hooks/common/useRedirectToBlog";
import { isEven } from "@/helper/helper";
import cls from "../styles/SolutionItem.module.scss";
type SolutionItemProps = {
  item: SolutionType;
};
const SolutionItem: React.FC<SolutionItemProps> = ({
  item
}) => {
  const isMobile = useMediaQuery({
    maxWidth: 550
  });
  const {
    handleClick
  } = useRedirectToBlog();
  return <div className={cn(cls.item_container, {
    [cls.reverse]: isEven(item.id)
  })} key={item.type} id={item.type} data-sentry-component="SolutionItem" data-sentry-source-file="SolutionItem.tsx">
      <div className={cls.text_container}>
        <div className={cls.text}>
          <div className={cls.title}>
            <Image width={30} height={30} src={`/types/${item.type}.svg`} alt="Type icon" data-sentry-element="Image" data-sentry-source-file="SolutionItem.tsx" />
            <h2>{item.title}</h2>
          </div>
          <p>{item.description}</p>
        </div>
        {!isMobile ? <Button onClick={() => handleClick(item.type, item.route)} title={"Start Testing"} /> : null}
      </div>
      <Image unoptimized width={0} height={0} src={item.image} alt={item.title} className={cls.type_img} loading="lazy" data-sentry-element="Image" data-sentry-source-file="SolutionItem.tsx" />
      {isMobile ? <Button onClick={() => handleClick(item.type, item.route)} title={"Create QR-Code"} /> : null}
    </div>;
};
export default SolutionItem;